import { Asset } from './asset';

export class ManualContent {
  static Types = {
    Title: 'TITLE',
    Text: 'TEXT',
    Image: 'IMAGE',
    Video: 'VIDEO',
    File: 'FILE',
    YouTube: 'YOUTUBE'
  };

  _id: string;
  id: string;
  index: number;
  lang: string;
  type: string;
  title: string;
  text: string;
  url: string;
  assets: Asset[];

  constructor(type: string) {
    this.type = type;
    if (this.type === ManualContent.Types.Text) {
      this.text = undefined;
    } else if (this.type === ManualContent.Types.Title) {
      this.title = undefined;
    } else if (this.type === ManualContent.Types.Image || this.type === ManualContent.Types.Video) {
      this.assets = [<Asset>{}];
    } else if (this.type === ManualContent.Types.File) {
      this.title = undefined;
      this.assets = [<Asset>{}];
    } else if (this.type === ManualContent.Types.YouTube) {
      this.url = undefined;
    }
  }

}
